import axios from 'axios';
import { ENV_SCALES_URL } from 'constants/routes';

const axiosConfig = axios.create({
  baseURL: ENV_SCALES_URL,
  withCredentials: true
});

export default axiosConfig;
